import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import('@/views/index/Index'),
      meta: {
        breadcrumbName: 'mainNav.nIndex'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/register/Register'),
    },
    {
      path: '/registersuccess',
      name: 'RegisterSuccess',
      component: () => import('@/views/register/RegisterSuccess')
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: () => import('@/views/Agreement')
    },
    {
      path: '/vip',
      name: 'VipCenter',
      component: () => import('@/views/vip/VipCenter'),
      redirect: '/vip/base',
      meta: {
        breadcrumbName: 'vipCenterPage.breadcrumb.aNavgation',
        requireAuth: true
      },
      children: [
        {
          path: 'base',
          name: 'Base',
          component: () => import('@/views/vip/Base'),
          meta: {
            breadcrumbName: 'vipCenterPage.sideNav.base'
          }
        },
        {
          path: 'bind',
          name: 'Binding',
          component: () => import('@/views/vip/Binding'),
          meta: {
            breadcrumbName: 'vipCenterPage.sideNav.bind'
          }
        },
        {
          path: 'unbind',
          name: 'UnBinding',
          component: () => import('@/views/vip/UnBinding'),
          meta: {
            breadcrumbName: 'vipCenterPage.sideNav.unbind'
          }
        },
        {
          path: 'record',
          name: 'Record',
          component: () => import('@/views/vip/Record'),
          meta: {
            breadcrumbName: 'vipCenterPage.sideNav.record'
          }
        },
        {
          path: 'modify',
          name: 'Modify',
          component: () => import('@/views/vip/modify/Modify'),
          redirect: 'modify/stepone',
          meta: {
            breadcrumbName: 'vipCenterPage.sideNav.modify'
          },
          children: [
            {
              path: 'stepone',
              name: 'ResetStepone',
              component: () => import('@/views/vip/modify/Stepone'),
              meta: {
                breadcrumbName: 'vipCenterPage.modifySteps.stepone'
              }
            },
            {
              path: 'steptwo',
              name: 'ResetSteptwo',
              component: () => import('@/views/vip/modify/Steptwo'),
              meta: {
                breadcrumbName: 'vipCenterPage.modifySteps.steptwo'
              }
            },
            {
              path: 'stepthree',
              name: 'ResetStepthree',
              component: () => import('@/views/vip/modify/Stepthree'),
              meta: {
                breadcrumbName: 'vipCenterPage.modifySteps.stepthree'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: () => import('@/views/recharge/Recharge'),
      redirect: '/recharge/buy',
      meta: {
        breadcrumbName: 'recharge.breadcrumb.aNavgation',
        requireAuth: true
      },
      children: [
        {
          path: 'buy',
          name: 'Buy',
          component: () => import('@/views/recharge/Buy'),
          meta: {
            breadcrumbName: 'recharge.sideNav.recharge'
          }
        },
        {
          path: 'exchange',
          name: 'Exchange',
          component: () => import('@/views/recharge/Exchange'),
          meta: {
            breadcrumbName: 'recharge.sideNav.exchange'
          }
        }
      ]
    },
    {
      path: '/forget',
      name: 'Forget',
      component: () => import('@/views/forget/Forget'),
      redirect: '/forget/stepone',
      children: [
        {
          path: 'stepone',
          name: 'Stepone',
          component: () => import('@/views/forget/Stepone'),
          meta: {
            activeIndex:0
          }
        },
        {
          path: 'steptwo',
          name: 'Steptwo',
          component: () => import('@/views/forget/Steptwo'),
          meta: {
            activeIndex:1
          }
        },
        {
          path: 'stepthree',
          name: 'Stepthree',
          component: () => import('@/views/forget/Stepthree'),
          meta: {
            activeIndex:2
          }
        },
        {
          path: 'stepfour',
          name: 'Stepfour',
          component: () => import('@/views/forget/Stepfour'),
          meta: {
            activeIndex:3
          }
        }
      ]
    },
    {
      path: '/404',
      name: 'Error404',
      component: () => import('@/views/errorPages/Page404')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js